export type DressColorHint = {
  algorithm_version: 'oklab-palette-rgb6-v1';
  asset_hash: string;
  labels: number[];
};

// Unsupported/failed local decoding omits the hint; Server analyzes the stored original.
export function analyzeDressPng(blob: Blob): Promise<DressColorHint | undefined> {
  return new Promise((resolve) => {
    let worker: Worker;
    try { worker = new Worker(new URL('./dressColor.worker.ts', import.meta.url), { type: 'module' }); }
    catch { resolve(undefined); return; }
    const finish = (hint?: DressColorHint) => { clearTimeout(timer); worker.terminate(); resolve(hint); };
    const timer = setTimeout(() => finish(), 30000);
    worker.onmessage = (event: MessageEvent<DressColorHint | undefined>) => finish(event.data);
    worker.onerror = () => finish();
    blob.arrayBuffer().then((buffer) => worker.postMessage(buffer, [buffer])).catch(() => finish());
  });
}
